// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"277950d4","453":"68583a31","469":"e1cce1a2","883":"276fc0fc","952":"be47b3fe"}[chunkId] + ".chunk.js";
};